<template>
    <div class="c-m-certificates">
        <div class="c-m-certificates__inner">
            <h3 class="c-m-certificates__heading">Certifikat</h3>
            <div class="c-m-certificates__content">
                <ul class="c-m-certificates__list">
                    <li v-for="cert in certificates" :key="`company-cert-${cert.CompanyCertID}`" class="c-m-certificates__cert">
                        <div class="c-m-certificates__cert-inner">
                            <div class="c-m-certificates__cert-logo">
                                <img :src="imagePrefix + cert.Image" :alt="`Logotyp för certifikatet ${cert.Name}`">
                            </div>
                            <div class="c-m-certificates__cert-info">
                                <p class="c-m-certificates__cert-title" v-html="cert.Name"></p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            certificates: {
                type: Array,
                default: ()=>([])
            }
        },
        computed:{
            //TODO: Put this fix in different layer (done here for now, since we cant update db (varchar limit to low))
            imagePrefix: function(){
                return 'https://static.brabyggare.se/certificates/';
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/components/molecules/MoleculeCertificates.vue